import { mapState, mapGetters, mapMutations } from 'vuex'

import Action from '@/mls-filter/components/Action.vue';
import FilterDialog from '@/mls-filter/components/filters/FilterDialog.vue';
import { startCase } from 'lodash';

export default {
    props: {
        name: String,
        defaultLabel: String,
        open: Boolean,
        options: Array,
        selected: [String, Number],
        align: String,
        size: String,
        disabled: Boolean,
    },
    data() {
        return {
            // moved selected up to FilterBaar
            // selected: this.initialSelected,
        };
    },
    computed: {
        label() {
            return this.defaultLabel || startCase(this.name);
        },
        display() {
            return this.defaultLabel || startCase(this.name);
        },
        sizeClass() {
            return this.size || this.options.length > 15 ? 'wide' : 'narrow';
        },
    },
    methods: {

        optionId(id) {
            return this.name + '-' + id;
        },
        getOption(id) {
            return this.options.find((opt) => (opt.id == id));
        },
        clickFilter() {
            if (!self.disabled) {
                this.$store.dispatch('toggleFilter', this.name);
            }
        },
        apply() {
            // console.log('Applying...')
        }

    },

    components: {
        'action': Action,
        'filter-dialog': FilterDialog,
    },
};